import { createSelector } from "@reduxjs/toolkit";

const getLanguageStore = (state) => state.language;

const getProntoSoccorsoStore = (state) => state.prontoSoccorso;

export const getElencoProntoSoccorso = createSelector(getProntoSoccorsoStore, (prontoSoccorso) => prontoSoccorso.elencoProntoSoccorso.data);

export const fetchElencoProntoSoccorsoEnded = createSelector(getProntoSoccorsoStore, (prontoSoccorso) => prontoSoccorso.elencoProntoSoccorso.fetchEnded); //prettier-ignore

export const getCodiciColore = createSelector(getProntoSoccorsoStore, getLanguageStore, (prontoSoccorso, language) => new Map(JSON.parse(prontoSoccorso.codiciColore.data)).get(language.locale)); //prettier-ignore

export const fetchCodiciColoreEnded = createSelector(getProntoSoccorsoStore, (prontoSoccorso) => prontoSoccorso.codiciColore.fetchEnded);

export const getFaq = createSelector(getProntoSoccorsoStore, getLanguageStore, (prontoSoccorso, language) => new Map(JSON.parse(prontoSoccorso.faq.data)).get(language.locale)); //prettier-ignore

export const fetchFaqEnded = createSelector(getProntoSoccorsoStore, (prontoSoccorso) => prontoSoccorso.faq.fetchEnded);

export const getCookiePolicy = createSelector(getProntoSoccorsoStore, getLanguageStore, (prontoSoccorso, language) => new Map(JSON.parse(prontoSoccorso.cookiePolicy.data)).get(language.locale)); //prettier-ignore

export const fetchCookiePolicyEnded = createSelector(getProntoSoccorsoStore, (prontoSoccorso) => prontoSoccorso.cookiePolicy.fetchEnded);

export const getContacts = createSelector(getProntoSoccorsoStore, getLanguageStore, (prontoSoccorso, language) => new Map(JSON.parse(prontoSoccorso.contacts.data)).get(language.locale)); //prettier-ignore

export const fetchContactsEnded = createSelector(getProntoSoccorsoStore, (prontoSoccorso) => prontoSoccorso.contacts.fetchEnded);

export const getPrivacyPsPolicy = createSelector(getProntoSoccorsoStore, getLanguageStore, (prontoSoccorso, language) => new Map(JSON.parse(prontoSoccorso.privacyPs.data)).get(language.locale)); //prettier-ignore

export const fetchPrivacyPsPolicyEnded = createSelector(getProntoSoccorsoStore, (prontoSoccorso) => prontoSoccorso.privacyPs.fetchEnded);
